
const m = window.require("@glimmer/env");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
